import { Box, Typography } from "@mui/material";
import { User } from "@/interfaces/User";
import { IconX } from "@tabler/icons-react";
import { Button } from "./ui/button";
import { useAppDispatch } from "@/redux/hooks";

import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { updateUser } from "@/redux/user/user.action";
import { RequestStatus } from "@/utilities/ResponseEnum/RequestStatus";
import { SuccessToast } from "@/utilities/toasts/SuccessToast";
import { ErrorToast } from "@/utilities/toasts/ErrorToast";
import { allUsers as fetchAllUsers } from "@/redux/user/user.action";

interface DialogProfileProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  userInfo: Partial<User>;
  newRole: string;
  setSelectedRole: (role: string) => void;
}

const DialogRoleConfirm = ({
  open,
  setOpen,
  userInfo,
  newRole,
  setSelectedRole,
}: DialogProfileProps) => {
  const dispatch = useAppDispatch();
  const handleConfirm = async () => {
    const response = await dispatch(
      updateUser({ user: { role: newRole }, userId: userInfo.id || "" }),
    );
    if (response.meta.requestStatus === RequestStatus.Fulfilled) {
      SuccessToast({ message: "Rol actualizado correctamente" });

      setSelectedRole(newRole);
      setOpen(false);
      await dispatch(fetchAllUsers());
    } else {
      ErrorToast({ message: "Error al actualizar el rol" });
      setOpen(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <VisuallyHidden>
        <DialogTitle>RolConfig</DialogTitle>
      </VisuallyHidden>
      <DialogContent className="bg-sidebar min-w-[15rem] w-[30rem]">
        <DialogHeader className="flex pb-0 h-fit">
          <Box className="flex justify-end w-full font-bold">
            <Button
              className="p-0 text-[#1F6B45] h-fit"
              onClick={() => setOpen(false)}
            >
              <IconX className="p-0" />
            </Button>
          </Box>
          <DialogTitle>
            <Typography fontFamily={"Inter"} fontSize={"18px"} fontWeight={500}>
              Cambiar rol
            </Typography>
          </DialogTitle>
          <DialogDescription className="text-sm text-gray-500">
            Estás seguro que quieres cambiar el rol de {userInfo.username} a{" "}
            {newRole}?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            className="justify-self-start w-[7.5rem] flex border-red-500 text-red-500 hover:bg-red-500 hover:text-white"
            onClick={() => setOpen(false)}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            className=" justify-self-end w-[7.5rem] flex hover:bg-[#1F6B45]/90"
            onClick={() => handleConfirm()}
          >
            Confirmar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DialogRoleConfirm;
